import { Authorization } from "Everou/_modelsTS/Authorization";
import { TimeHelper } from "../_helpers";

export class AuthorizationMapper {
    static allServerToLocal(serverAuthorizations = []) {
        return serverAuthorizations.map(this.serverToLocal);
    }

    static serverToLocal(serverAuthorization): Authorization {

        const createdOnString = TimeHelper.serverStringToIsoString(serverAuthorization.created_on);
        const signedOnString = TimeHelper.serverStringToIsoString(serverAuthorization.signed_on);
        const revokedOnString = TimeHelper.serverStringToIsoString(serverAuthorization.revoked_on);

        return {
            uid:        serverAuthorization.uid,
            locUid:     serverAuthorization.loc_uid,
            type:       serverAuthorization.type,
            state:      serverAuthorization.state,
            documentUrl:      serverAuthorization.document_url,
            createdOn: createdOnString ? new Date(createdOnString) : undefined,
            signedOn: signedOnString ? new Date(signedOnString) : undefined,
            revokedOn: revokedOnString ? new Date(revokedOnString) : undefined,
        };
    }
}